// extracted by mini-css-extract-plugin
export default {"Container":"CTAMessage_Container__2HtDt","Row":"CTAMessage_Row__d7xV1","LeftColumn":"CTAMessage_LeftColumn__afIWR","RightColumn":"CTAMessage_RightColumn__Ii-1g"};